import { render, staticRenderFns } from "./member-info.vue?vue&type=template&id=04a18b6a&scoped=true&"
import script from "./member-info.vue?vue&type=script&lang=js&"
export * from "./member-info.vue?vue&type=script&lang=js&"
import style0 from "./member-info.vue?vue&type=style&index=0&id=04a18b6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a18b6a",
  null
  
)

export default component.exports